import React, { useEffect } from "react";
import { toast, Bounce } from 'react-toastify';
import { config } from '../helper/configVariable.js'

const Notifications = () => {
    useEffect(() => {
        const eventSource = new EventSource(`${config.BASE_URL}/events`);

        eventSource.onmessage = (event) => {
            const data = JSON.parse(event.data);
            const receivedUser = `${data.split("@")[0]}@${config.DOMAIN}`;
            const userdata = JSON.parse(localStorage.getItem('user'));
            const userName = userdata.wallet.username;
            if (receivedUser === userName) {
                window.dispatchEvent(new Event("REFRESH_COUNT"));
                const notifyMessage = `New email received`;
                toast.info(notifyMessage, {
                    position: "top-right",
                    transition: Bounce,
                });
            }
        };

        eventSource.onerror = (error) => {
            console.error('EventSource failed:', error);
            eventSource.close();
        };

        return () => {
            eventSource.close();
        };
    }, []);


    return (
        <>
            {/* The Notifications component currently does not render any visible UI */}
        </>
    );
}

export default Notifications;